(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-selector"] && !Shopify.designMode) return;
  try {
    function updatePmuLocaleLinks() {
    const alternates = Array.from(document.head.querySelectorAll('link[rel="alternate"][hreflang]'));
    document.querySelectorAll('a[data-pmu-locale-link]').forEach((link) => {
      const language = link.dataset.pmuLocaleLink;
      const alternate = alternates.find((item) => item.hreflang.toLowerCase() === language)
        || alternates.find((item) => item.hreflang.toLowerCase().startsWith(language + '-'));
      if (!alternate) return;
      const destination = new URL(alternate.href, document.baseURI);
      if (!['www.pmutrend.com', 'pmutrend.com', 'www.pmutrend.es', 'pmutrend.es'].includes(destination.hostname)) return;
      const previewId = new URL(link.href, document.baseURI).searchParams.get('preview_theme_id');
      if (previewId) destination.searchParams.set('preview_theme_id', previewId);
      link.href = destination.href;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updatePmuLocaleLinks, { once: true });
  } else {
    updatePmuLocaleLinks();
  }
  document.addEventListener('shopify:section:load', updatePmuLocaleLinks);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pmu-learning-hub"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-pt-learning-back]').forEach(button=>{
  button.addEventListener('click',()=>{
    if(document.referrer && new URL(document.referrer).origin===location.origin && history.length>1){history.back();}
    else{location.assign(button.dataset.fallback);}
  });
});
  } catch(e) { console.error(e); }
})();

})();
